export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
  REDIRECT_ON_OPTIONS: {"ALL":"all","ROOT":"root","NO_PREFIX":"no prefix"},
}
export const nuxtOptions = {
  isUniversalMode: true,
  trailingSlash: undefined,
}
export const options = {
  vueI18n: {"numberFormats":{"ie":{"currency":{"style":"currency","currency":"EUR","minimumFractionDigits":2,"maximumFractionDigits":2},"decimal":{"style":"decimal","minimumFractionDigits":2,"maximumFractionDigits":2}}}},
  vueI18nLoader: false,
  locales: [{"code":"ie","iso":"en-IE","file":"index.js"}],
  defaultLocale: "ie",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "prefix_except_default",
  lazy: true,
  langDir: "lang/",
  rootRedirect: null,
  detectBrowserLanguage: {"alwaysRedirect":false,"cookieAge":365,"cookieCrossOrigin":false,"cookieDomain":null,"cookieKey":"i18n_redirected","cookieSecure":false,"fallbackLocale":"","redirectOn":"root","useCookie":true},
  differentDomains: false,
  baseUrl: "",
  vuex: {"moduleName":"i18n","syncRouteParams":true},
  parsePages: true,
  pages: {},
  skipSettingLocaleOnNavigate: false,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  normalizedLocales: [{"code":"ie","iso":"en-IE","file":"index.js"}],
  localeCodes: ["ie"],
  additionalMessages: [],
}
export const localeFiles = {
  0: "{",
  1: "\"",
  2: "i",
  3: "n",
  4: "d",
  5: "e",
  6: "x",
  7: ".",
  8: "j",
  9: "s",
  10: "\"",
  11: ":",
  12: "\"",
  13: ".",
  14: ".",
  15: "/",
  16: "l",
  17: "a",
  18: "n",
  19: "g",
  20: "/",
  21: "i",
  22: "n",
  23: "d",
  24: "e",
  25: "x",
  26: ".",
  27: "j",
  28: "s",
  29: "\"",
  30: "}",
}

export const localeMessages = {
  'index.js': () => import('../../lang/index.js' /* webpackChunkName: "lang-index.js" */),
}
